<template>
  <div id="setup-done" class="kp-flat-card small-shadow text-center d-flex h-100 justify-content-center align-items-center">
    <div>
      <h4>Great {{ user.firstName }}</h4>
      <p>Your setup is done and from now you can enjoy your Dashboard.</p>
      <div class="text-center pt-20 pb-40">
        <img src="@/assets/working-man.png" alt="man working" :style="{maxWidth: '220px'}" />
      </div>
      <button class="btn" @click="toDashboard()">Go to Dashboard</button>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'setup-done',
  computed: {
    ...mapFields({
      user: 'user'
    })
  },
  methods: {
    toDashboard() {
      this.$store.commit('changeRegisterStatus', {
        key: 'complete',
        val: true
      })
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>
